export class RegistryType {
    name: string;
    id: number;
    code: number;
}